enum RolesType {
    VIEWER_DASHBOARD = 'viewer_dashboard',
    EDITOR_DASHBOARD = 'editor_dashboard',
    ADMIN_TENANT = 'admin_tenant',
    ADMIN = 'Admin',
    ADMIN_MOAI = 'admin_moai'
}

export default RolesType;
